import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Grid, Box } from '@mui/material';
import { CustomInput } from '../../../../components/CustomInput';
import { ValidationError } from '../ValidationError';
import { LANGUAGES } from '../../constants';

export const PromotionBasicInfo = ({ 
  formData, 
  onInputChange,
  errors = {}
}) => {
  return (
    <Card sx={{ mb: 3, boxShadow: 2 }}>
      <CardContent>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600, color: 'black' }}>
          Название акции
        </Typography>
        <Grid container spacing={3}>
          {LANGUAGES.map(lang => (
            <Grid item xs={12} md={4} key={lang.value}>
              <Box>
                <CustomInput
                  placeholder={`Название акции (${lang.label})`}
                  value={formData[`name_${lang.value}`]}
                  onChange={(e) => onInputChange(`name_${lang.value}`, e.target.value)}
                  required
                  fullWidth
                  error={!!errors[`name_${lang.value}`]}
                />
                <ValidationError error={errors[`name_${lang.value}`]} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

PromotionBasicInfo.propTypes = {
  formData: PropTypes.object.isRequired,
  onInputChange: PropTypes.func.isRequired,
  errors: PropTypes.object
};
